<template>
    <span>{{cartItemsTotal}}</span>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    name: "CartCounter",
    methods: {
        ...mapActions(['cartItemsCountAction']),
        updateCartCount() {
            // update cart items counter via vuex action
            this.cartItemsCountAction().then(() => {}).catch((e) => {})
        }
    },
    computed: {
        ...mapGetters(['cartItemsCount']),
        cartItemsTotal() {
			// display count to total cart items
            if(this.cartItemsCount) {
                return this.cartItemsCount
            }
            return 0 // show empty cart by default
		},
    },
    created() {
        // auto load and display cart items count if any
        this.updateCartCount()
    }
}
</script>
